import { Button, Divider, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { privateAxiosIntance } from "../../Config/axios";

const Customization = () => {
  const [type, setType] = useState("Background");
  const [color, setColor] = useState("#ffffff"); // default white
  const [selectedFont, setSelectedFont] = useState({ Font: "", url: "" });
  const types = ["Background", "Font"];

  const fonts = [
    { Font: "Roboto", url: "https://fonts.googleapis.com/css?family=Roboto" },
    {
      Font: "Open Sans",
      url: "https://fonts.googleapis.com/css?family=Open+Sans",
    },
    { Font: "Lato", url: "https://fonts.googleapis.com/css?family=Lato" },
    {
      Font: "Montserrat",
      url: "https://fonts.googleapis.com/css?family=Montserrat",
    },
    {
      Font: "Roboto Condensed",
      url: "https://fonts.googleapis.com/css?family=Roboto+Condensed",
    },
    {
      Font: "Roboto Slab",
      url: "https://fonts.googleapis.com/css?family=Roboto+Slab",
    },
    { Font: "Oswald", url: "https://fonts.googleapis.com/css?family=Oswald" },
    {
      Font: "Source Sans Pro",
      url: "https://fonts.googleapis.com/css?family=Source+Sans+Pro",
    },
    { Font: "PT Sans", url: "https://fonts.googleapis.com/css?family=PT+Sans" },
    { Font: "Nunito", url: "https://fonts.googleapis.com/css?family=Nunito" },
    { Font: "Poppins", url: "https://fonts.googleapis.com/css?family=Poppins" },
    // Cursive / Handwriting fonts
    {
      Font: "Dancing Script",
      url: "https://fonts.googleapis.com/css?family=Dancing+Script",
    },
    {
      Font: "Pacifico",
      url: "https://fonts.googleapis.com/css?family=Pacifico",
    },
    {
      Font: "Great Vibes",
      url: "https://fonts.googleapis.com/css?family=Great+Vibes",
    },
    { Font: "Allura", url: "https://fonts.googleapis.com/css?family=Allura" },
    {
      Font: "Kaushan Script",
      url: "https://fonts.googleapis.com/css?family=Kaushan+Script",
    },
    {
      Font: "Sacramento",
      url: "https://fonts.googleapis.com/css?family=Sacramento",
    },
    { Font: "Satisfy", url: "https://fonts.googleapis.com/css?family=Satisfy" },
    {
      Font: "Alex Brush",
      url: "https://fonts.googleapis.com/css?family=Alex+Brush",
    },
    { Font: "Caveat", url: "https://fonts.googleapis.com/css?family=Caveat" },
    {
      Font: "Homemade Apple",
      url: "https://fonts.googleapis.com/css?family=Homemade+Apple",
    },
    // Additional Sans-serif
    { Font: "Raleway", url: "https://fonts.googleapis.com/css?family=Raleway" },
    {
      Font: "Merriweather Sans",
      url: "https://fonts.googleapis.com/css?family=Merriweather+Sans",
    },
    { Font: "Ubuntu", url: "https://fonts.googleapis.com/css?family=Ubuntu" },
    {
      Font: "Fira Sans",
      url: "https://fonts.googleapis.com/css?family=Fira+Sans",
    },
    {
      Font: "Cantarell",
      url: "https://fonts.googleapis.com/css?family=Cantarell",
    },
    // Additional Serif
    {
      Font: "Merriweather",
      url: "https://fonts.googleapis.com/css?family=Merriweather",
    },
    {
      Font: "Playfair Display",
      url: "https://fonts.googleapis.com/css?family=Playfair+Display",
    },

    {
      Font: "Crimson Text",
      url: "https://fonts.googleapis.com/css?family=Crimson+Text",
    },
    { Font: "Lora", url: "https://fonts.googleapis.com/css?family=Lora" },
    // Additional Cursive / Handwriting
    {
      Font: "Indie Flower",
      url: "https://fonts.googleapis.com/css?family=Indie+Flower",
    },
    {
      Font: "Shadows Into Light",
      url: "https://fonts.googleapis.com/css?family=Shadows+Into+Light",
    },
    {
      Font: "Courgette",
      url: "https://fonts.googleapis.com/css?family=Courgette",
    },
    {
      Font: "Yellowtail",
      url: "https://fonts.googleapis.com/css?family=Yellowtail",
    },

    {
      Font: "Quicksand",
      url: "https://fonts.googleapis.com/css2?family=Quicksand",
    },
  ];
  // Fetch current settings
  const fetchSettings = () => {
    privateAxiosIntance
      .get("blog/superadmin-manage-store-api/", {
        params: { store_id: localStorage.getItem("store_id") },
      })
      .then((res) => {
        const data = res?.data?.data;
        setColor(data.background_color || "#ffffff");
        setSelectedFont({
          Font: data.font_style || "Roboto",
          url: data.font_style_url || fonts[0].url,
        });
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchSettings();

    // Load fonts dynamically
    const links = fonts.map((f) => {
      const link = document.createElement("link");
      link.href = f.url;
      link.rel = "stylesheet";
      document.head.appendChild(link);
      return link;
    });
    return () => links.forEach((l) => document.head.removeChild(l));
  }, []);

  const handleSubmit = () => {
    const formdata = new FormData();
    type === "Background" && formdata.append("background_color", color);
    type === "Font" && formdata.append("font_style", selectedFont?.Font);
    type === "Font" && formdata.append("font_style_url", selectedFont?.url);
    formdata.append("store_id", localStorage.getItem("store_id"));

    privateAxiosIntance
      .patch("blog/superadmin-manage-store-api/", formdata)
      .then((res) => {
        toast.success(res.data.message);
        fetchSettings();
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Something went wrong"),
      );
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 md:p-10">
      <div className="max-w-6xl mx-auto bg-white shadow-md rounded-lg p-4 sm:p-6 md:p-8">
        {/* Type Selector */}
        <div className="flex flex-wrap gap-2 mb-4">
          {types.map((t) => (
            <Button
              key={t}
              variant={type === t ? "contained" : "outlined"}
              color="secondary"
              onClick={() => setType(t)}
              className="capitalize"
            >
              {t}
            </Button>
          ))}
        </div>
        <Divider className="mb-4" />

        {/* Background Picker */}
        {type === "Background" && (
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-between">
            <div className="flex flex-col items-center gap-3">
              <Typography variant="h6">Select Background Color</Typography>
              <input
                type="color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                className="w-16 h-12 cursor-pointer rounded border border-gray-300"
              />
            </div>
            <div
              className="w-48 h-48 rounded border border-gray-300 mt-4 sm:mt-0"
              style={{ backgroundColor: color }}
            />
          </div>
        )}

        {/* Font Selector */}
        {type === "Font" && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {fonts.map((font) => (
              <Button
                key={font.Font}
                variant={
                  selectedFont.Font === font.Font ? "contained" : "outlined"
                }
                color="secondary"
                className="w-full h-12 text-sm sm:text-base overflow-hidden truncate"
                style={{ fontFamily: font.Font }}
                onClick={() =>
                  setSelectedFont({ Font: font.Font, url: font.url })
                }
              >
                {font.Font}
              </Button>
            ))}
          </div>
        )}

        {/* Submit Button */}
        <div className="flex justify-center mt-6">
          <Button onClick={handleSubmit} variant="contained" color="warning">
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Customization;
